import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Typography } from "@mui/material";
const EmptyStateMessage = React.memo(({ noDataMessage }) => {
    return typeof noDataMessage === "string" ? (_jsx(Typography, Object.assign({ variant: "body2" }, { children: noDataMessage }))) : (_jsx(_Fragment, { children: noDataMessage }));
});
EmptyStateMessage.displayName = "EmptyStateMessage";
export default EmptyStateMessage;
